__turbopack_context__.v({
  "card": "JnhXXa_card",
  "checkouts-disabled": "JnhXXa_checkouts-disabled",
  "confirmation-row": "JnhXXa_confirmation-row",
  "input-grid": "JnhXXa_input-grid",
  "input-row-1": "JnhXXa_input-row-1",
  "input-row-2": "JnhXXa_input-row-2",
  "placeholder": "JnhXXa_placeholder",
  "section": "JnhXXa_section",
  "solar-teaser": "JnhXXa_solar-teaser",
  "unit": "JnhXXa_unit",
});
